

















































import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteButton from '../components/VoteButton.vue';
import { list } from '../api';
Vue.use(List);
@Component({
  components: {
    SearchBar,
    VoteButton,
  },
})
export default class ListPage extends Vue {
  voteName: string = '2021project/q4/2021pension_brand';
  text: any = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  placeholder: string = '请输入单位名称';
  inputText: string = '';
  title: any = '';
  created() {
    this.title = this.$route.query.text;
    this.text = this.$route.query.id;
  }
  onLoad() {
    list(this.text, this.page, this.inputText).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
  }
  userInputChange(text: string) {
    this.inputText = text;
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  votSuccess(data: any, index: any) {
    this.list[index].votes = data;
  }
  // goBack() {
  //   window.location.href =
  //     'https://testdev.cqcb.com/2021h2/lao-dong-jiao-yu/home';
  // }
}
